module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [(_vm.speciesData.name === '') ? _c('DisplayProgressNumbers', {
    attrs: {
      "title": _vm.displayProgressNumbersTitle,
      "sigup-message": _vm.displayProgressNumbersSigupMessage,
      "goal-message": _vm.displayProgressNumbersGoalMessage,
      "datalayerName": _vm.datalayerName,
      "petition-goal": _vm.displayProgressNumbersPetitionGoal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.speciesData.name === '') ? _c('div', {
    staticClass: "cards"
  }, [_vm._m(0, false, false), _vm._v(" "), _vm._l((_vm.cards), function(card, index) {
    return _c('div', {
      key: index,
      staticClass: "species-card"
    }, [_c('Card', {
      attrs: {
        "isReversed": index % 2 === 1,
        "pictureUrl": card.pictureUrl,
        "title": card.title,
        "description": card.description
      }
    })], 1)
  })], 2) : _vm._e(), _vm._v(" "), (_vm.speciesData.name === '') ? _c('RecoveryGradeStatus', {
    attrs: {
      "title": _vm.recoveryGradeStatusTitle,
      "subtitle": _vm.recoveryGradeStatusSubtitle,
      "legend": _vm.recoveryGradeStatusLegend,
      "description": _vm.recoveryGradeStatusDescription
    }
  }) : _vm._e(), _vm._v(" "), (_vm.speciesData.name !== '') ? _c('div', {
    staticClass: "hero-species"
  }, [_c('HeroSpecies'), _vm._v(" "), _c('ActionForm', {
    attrs: {
      "datalayerName": _vm.datalayerName,
      "programName": _vm.programName,
      "sendToIve": _vm.sendToIve,
      "iveSupplier": _vm.iveSupplier,
      "iveSource": _vm.iveSource,
      "iveCampaignId": _vm.iveCampaignId,
      "messageId": _vm.messageId,
      "thankYouUrl": _vm.thankYouUrl,
      "privacyPolicyUrl": _vm.privacyPolicyUrl,
      "form-header-title": _vm.formHeaderTitle,
      "form-supporter-details-title": _vm.formSupporterDetailsTitle,
      "form-supporter-details-subtitle": _vm.formSupporterDetailsSubtitle
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "partners"
  }, [_c('Partners')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h2', [_vm._v("My Backyard")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n        Learn about the wildlife that call your backyard home\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51d10882","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=trkhxoihlnq!./~/string-replace-webpack-plugin/loader.js?id=gism0w5tdia!./src/components/threatened-species/SpeciesDetails.vue
// module id = 808
// module chunks = 0